import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zoneClass } from '../utils/forensicDisplay';
import ForensicPlainLanguageBlock from './ForensicPlainLanguageBlock';

export default function ForensicVerdictBanner({ axis, verdict, onAskAgent }) {
    if (!verdict) return null;
    const title = axis === 'solvency' ? 'Solvency' : 'Manipulation risk';
    const zone =
        verdict.label === 'Clean' || verdict.label === 'Strong' ? 'green' :
            verdict.label === 'Distress' || verdict.label === 'Red Flag' ? 'red' :
                verdict.label === 'Unavailable' ? 'neutral' :
                    'yellow';

    return (
        <section className={`forensic-banner ${zoneClass(zone)}`} data-axis={axis}>
            <div className="forensic-banner__eyebrow-row">
                <div className="forensic-banner__eyebrow">{title}</div>
                {axis === 'manipulation' && onAskAgent && (
                    <button
                        type="button"
                        className="forensic-info forensic-agent"
                        aria-label="Ask forensic agent about manipulation risk"
                        onClick={() => onAskAgent({ title })}
                    >
                        <FontAwesomeIcon icon="robot" />
                    </button>
                )}
            </div>
            <div className="forensic-banner__row">
                <span className="forensic-banner__label">{verdict.label}</span>
                {verdict.dataVintage && (
                    <span className="forensic-banner__vintage">{verdict.dataVintage}</span>
                )}
            </div>
            <ForensicPlainLanguageBlock
                plain={verdict.plainLanguage || verdict.plain_language}
                technical={verdict.summary}
            />
            {verdict.confidence && (
                <p className="forensic-banner__confidence">{verdict.confidence}</p>
            )}
        </section>
    );
}
